import React from 'react';

const ShippingPolicyPage: React.FC = () => {
  const lastUpdated = "June 16, 2025";

  return (
    <div className="container mx-auto px-4 py-8 text-foreground">
      <h1 className="text-4xl font-bold mb-8 text-primary text-center">Shipping Policy</h1>
      <p className="mb-6 text-lg text-center text-muted-foreground">
        Last Updated: {lastUpdated}
      </p>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">1. Our Services</h2>
        <p className="text-muted-foreground leading-relaxed">
          Clipoid primarily offers digital services and software. As such, traditional shipping policies 
          regarding physical goods do not typically apply to most of our offerings. Access to our services 
          is generally provided electronically upon successful subscription or purchase.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">2. Digital Delivery</h2>
        <p className="text-muted-foreground leading-relaxed">
          All digital products and services are delivered electronically. After your purchase or subscription 
          is confirmed, you will receive access to the services through your Clipoid account. 
          Instructions for accessing and using the services will be provided via email or within your account dashboard.
        </p>
        <p className="text-muted-foreground leading-relaxed mt-2">
          There are no shipping fees associated with our digital services.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">3. Future Physical Products</h2>
        <p className="text-muted-foreground leading-relaxed">
          In the event that Clipoid offers physical products in the future (e.g., merchandise, physical media), 
          this Shipping Policy will be updated to include relevant details such as shipping methods, costs, 
          delivery times, and international shipping options.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-3">4. Contact Us</h2>
        <p className="text-muted-foreground leading-relaxed">
          If you have any questions about our Shipping Policy or how our services are delivered, 
          please contact us at support@clipoid.com.
        </p>
      </section>
    </div>
  );
};

export default ShippingPolicyPage;